module.exports = __webpack_public_path__ + "static/media/Slide1.4a862e27.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/Slide1.webp
// module id = 574
// module chunks = 4